import AllianceCard from './AllianceCard';

export { AllianceCard };
export default AllianceCard;
